import { render, staticRenderFns } from "./hot-merchant.vue?vue&type=template&id=9e750a1c&scoped=true"
import script from "./hot-merchant.vue?vue&type=script&lang=ts&setup=true"
export * from "./hot-merchant.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./hot-merchant.vue?vue&type=style&index=0&id=9e750a1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e750a1c",
  null
  
)

export default component.exports